// projects/humanresources-personnel/src/assets/i18n/*/hr-per-object-connection.json
export class HrPerObjectConnectionKey {
    private static readonly keyPrefix = 'hrPerObjectConn';
    public static title = `${HrPerObjectConnectionKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerObjectConnectionKey.keyPrefix}.pageHeader`;
    public static list1 = `${HrPerObjectConnectionKey.keyPrefix}.list1`;
    public static list2 = `${HrPerObjectConnectionKey.keyPrefix}.list2`;
    public static type = `${HrPerObjectConnectionKey.keyPrefix}.type`;
    public static enumTrue = `${HrPerObjectConnectionKey.keyPrefix}.enumTrue`;
    public static enumFalse = `${HrPerObjectConnectionKey.keyPrefix}.enumFalse`;
}
